import { SvgIconProps } from '@traba/types'

export default function Stop({
  size = 24,
  color = 'currentColor',
  ...props
}: SvgIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} {...props}>
      <rect x="6" y="6" width="12" height="12" rx="1" />
    </svg>
  )
}
